<template>
	<div class="body">
		<div class="box" id='loading'>
			<div class="loader3"></div>
		</div>
		<div id="container" @click="centerShow=false"></div>
		
		</div>
		<div class="bottom-layer"> 
			<div v-for="(item,index) in btnArray"  @click="chooseBtn(item,index)">
				<button class="custom-btn btn-3"><span>{{item.name}}</span></button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		init,
		textUploadModel
	} from "@/utils/threeInit.js";
	import globalData from "@/utils/globalData.js";
	import Destination from "@/utils/util.js";
	import * as echarts from 'echarts';
	
	export default {
		name: 'stk',
		data() {
			return {
				centerShow: false,
				productDistribution:{
					averageResponseTime:'2.1',
					averageHandlingTime:'1',
					positiveReviewRate:'98'
				},
				equipmentOperationAll:{
					"7day":100,
					"maximum":100
				},
				equipmentOperation:[
					{
						name: '浙江省',
						value:'100%',
					},
					{
						name: '北京市',
						value:'100%',
					},
					{
						name: '宁夏回族自治区',
						value:'100%',
					},
					{
						name: '湖南省',
						value:'100%',
					},
				],
				equipmentCommissioningAll:{
					"equipmentCommissioning":100,
					"equipmentForThisYear":100
				},
				equipmentCommissioning: [
					{
						name: '浙江省',
						projectNum:'321',
						equipmentNum:'3213123',
					},
					{
						name: '北京市',
						projectNum:'11',
						equipmentNum:'555555',
					},
					{
						name: '宁夏回族自治区',
						projectNum:'23',
						equipmentNum:'111231',
					},
					{
						name: '湖南省',
						projectNum:'31231233',
						equipmentNum:'312312',
					},
					{
						name: '西藏自治区',
						projectNum:'44',
						equipmentNum:'757575',
					},
					{
						name: '陕西省',
						projectNum:'55',
						equipmentNum:'1000000',
					},
					{
						name: '重庆市',
						projectNum:'6666',
						equipmentNum:'6666',
					},
				],
				btnArray: [{
						name: '展示位1',
						active: ''
					},
					{
						name: '展示位2',
						active: ''
					},
					{
						name: '展示位3',
						active: ''
					},
					{
						name: '展示位4',
						active: ''
					},
				],
				afterSalesGuarantee:[
					{ value: 40, name: 'rose 1' },
					{ value: 38, name: 'rose 2' },
					{ value: 32, name: 'rose 3' },
					{ value: 30, name: 'rose 4' },
					{ value: 28, name: 'rose 5' },
					{ value: 26, name: 'rose 6' },
					{ value: 22, name: 'rose 7' },
					{ value: 18, name: 'rose 8' }
				],
				chooseName:'',
				globalData: '',
				timer:'',
				scrollTop:0,
				scrollData:''
			}
		},
		created() {
			this.btnArray[0].active = true
			this.globalData = globalData
		},
		mounted() {
			let data = localStorage.getItem("equipmentCommissioning");
			if(data){
				data=JSON.parse(data)
				this.equipmentCommissioning=data.equipmentCommissioning
				let num=0
				for(let i=0;i<data.equipmentCommissioning.length;i++){
					num += Number(data.equipmentCommissioning[i].equipmentNum)
				}
				this.equipmentCommissioningAll={
					"equipmentCommissioning":num,
					"equipmentForThisYear":data.equipmentForThisYear
				}
				this.equipmentOperationAll=data.equipmentOperationAll
				this.equipmentOperation=data.equipmentOperation
				this.afterSalesGuarantee=data.afterSalesGuarantee
				this.productDistribution=data.productDistribution
			}
			init(this.equipmentCommissioning)
			//this.greatChat(this.afterSalesGuarantee)
			//this.greatReview(this.productDistribution.positiveReviewRate)
		},
		unmounted() {
			clearInterval(this.timer)
		},
		watch: {
			'globalData.chooseIndex'() {
				Destination.uploadModel()
				textUploadModel()
			}
		},
		methods: {
			greatReview(values){
				var chartDom = document.getElementById('reviewRate');
				var myChart = echarts.init(chartDom);
				var option;
				option =  {
					series: [
						{
						  type: 'gauge',
						  center: ['50%', '50%'],
						  startAngle: 200,
						  endAngle: -20,
						  min: 0,
						  max: 60,
						  splitNumber: 12,
						  itemStyle: {
							color: '#58D9F9'
						  },
						  progress: {
							show: true,
							width: 30
						  },
						  pointer: {
							show: false
						  },
						  axisLine: {
							lineStyle: {
							  width: 30
							}
						  },
						  axisTick: {
							distance: -45,
							splitNumber: 5,
							lineStyle: {
							  width: 2,
							  color: '#999'
							}
						  },
						  splitLine: {
							distance: -52,
							length: 14,
							lineStyle: {
							  width: 3,
							  color: '#999'
							}
						  },
						  axisLabel: {
							distance: -20,
							color: '#999',
							fontSize: 20
						  },
						  anchor: {
							show: false
						  },
						  title: {
							show: false
						  },
						  detail: {
							valueAnimation: true,
							width: '60%',
							lineHeight: 40,
							borderRadius: 8,
							offsetCenter: [0, '-15%'],
							fontSize: 60,
							fontWeight: 'bolder',
							formatter: function (value) {
							          return '{value|' + value.toFixed(0) + '}{unit|%}';
							        },
							color: 'inherit',
							rich: {
							          value: {
							            fontSize: 50,
							            fontWeight: 'bolder',
							            color: '#ffffff'
							          },
							          unit: {
							            fontSize: 20,
							            color: '#999',
							            padding: [0, 0, -20, 10]
							          }
							        }
						  },
						  data: [
							{
								value: values,
							}
						  ]
						},
						{
						  type: 'gauge',
						  center: ['50%', '50%'],
						  startAngle: 200,
						  endAngle: -20,
						  min: 0,
						  max: 60,
						  itemStyle: {
							color: '#4ec3dd'
						  },
						  progress: {
							show: true,
							width: 8
						  },
						  pointer: {
							show: false
						  },
						  axisLine: {
							show: false
						  },
						  axisTick: {
							show: false
						  },
						  splitLine: {
							show: false
						  },
						  axisLabel: {
							show: false
						  },
						  detail: {
							show: false
						  },
						  data: [
							{
								value: values,
								name: 'xxxxxx',
								title: {
									color:'#b5b5b5'
								},								
							}
						  ]
						}
					  ]
					};
				option && myChart.setOption(option);
			},
			greatChat(values){
				var chartDom = document.getElementById('distribution');
				var myChart = echarts.init(chartDom, 'dark');
				var option;
				option = {
				  legend: {
				    top: 'bottom'
				  },
				  series: [
				    {
				      name: 'Nightingale Chart',
				      type: 'pie',
				      radius: [50, 180],
				      center: ['50%', '50%'],
				      roseType: 'area',
				      itemStyle: {
				        borderRadius: 8
				      },
				      data: values
				    }
				  ]
				};
				option && myChart.setOption(option);
			},
			creatTableScroll(str){
				let arr=[]
				for(let i=0;i<this[str].length;i++){
					arr.push(this[str][i])
					arr[i].index=i+1
				}
				if(this[str].length>5){
					this.scrollData = arr.concat(arr)
					this.timer=setInterval(()=>{
						this.goScroll()
					},1000)
				}else{
					this.scrollData = arr
				}
			},
			goScroll(){ 
				let scroll=document.getElementById('tableScroll')
				scroll.scrollTo({top: this.scrollTop,behavior: 'smooth'});
				if(this.scrollTop>=this.equipmentCommissioning.length*50){
					this.scrollTop=0
					setTimeout(()=>{
						scroll.scrollTo({top:0});
					},100)
				}
				this.scrollTop += 50
			},
			chooseBtn(item,index) {
				this.btnArray = this.$options.data.call(this).btnArray
				this.centerShow = true
				item.active = true
				this.chooseName = item.name
				this.$set(this.btnArray,index,item)
				clearInterval(this.timer)
				this.scrollTop=0
				switch(index){
					case 0:
						this.creatTableScroll('equipmentCommissioning')
					break;
					case 1:
						this.creatTableScroll('equipmentOperation')
					break;
					case 2:
						
					break;
					case 3:
		
					break;
				}
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.after-down{
		background-image: url('../utils/map/afterSales.png');
		background-repeat: no-repeat;
		background-size:cover;
		width: 500px;
		height: 300px;
		margin-top: 70px;
	}
	.down-title{
		height: 150px;
		line-height: 150px;
		font-size: 25px;
	}
	.pop-titles{
		font-size: 35px;
		color: #8ACFFF;
	}
	.table-img{
		width: 50px;
		text-align: center;
		height: auto;
		margin-top: 10px;
	}
	#distribution{
		width: 40vw;
		height: 450px;
		margin: 0 auto;
	}
	.pop-table-head{
		border: 1px solid #5DBBFF;
		border-radius: 10px;
		color: #5DBBFF;
		margin-bottom: 10px;
		height: 40px;
		width: 100%;
		line-height: 40px;
		margin-top: 40px;
		display: flex;
		justify-content: space-between;
		font-weight: bold;
	}
	.pop-table-con{
		display: flex;
		justify-content: space-between;
		border-radius: 10px;
		color: #fff;
		height: 40px;
		width: 100%;
		line-height: 40px;
		background-color: #151e46;
		margin-top: 10px;
	}
	.pop-table-head>div,.pop-table-con>div{
		width: 33.3333%;
	}
	.pop-table-scroll{
		height: 250px;
		overflow: hidden;
	}
	.poplayer{
		width: 70%;
		margin: 60px auto 0;
	}
	.pop-head{
		display: flex;
		justify-content: space-between;
		color: #fff;
		margin-bottom: 20px;
	}
	.pop-img{
		font-size: 28px;
		font-family: Source Han Sans CN, Source Han Sans CN;
		font-weight: bold;
		line-height: 50px;
		color: #8ACFFF;
	}
	.pop-title{
		color: #99AFCC;
		font-size: 20px;
		line-height: 40px;
	}
	
	.box {
		height: 100vh;
		width: 100%;
		position: absolute;
		z-index: 99;
		background-color: rgba(45, 62, 80);
		/*margin:0 -4px -5px -2px;*/
		transition: all .2s ease;
	}

	.loader3 {
		position: relative;
		width: 150px;
		height: 20px;
		text-align: center;
		top: 45%;
		top: -webkit-calc(50% - 10px);
		top: calc(50% - 10px);
		left: 25%;
		left: -webkit-calc(50% - 75px);
		left: calc(50% - 75px);
	}

	.loader3:after {
		content: "LOADING ...";
		color: #fff;
		font-weight: 200;
		font-size: 16px;
		position: absolute;
		width: 100%;
		height: 20px;
		line-height: 20px;
		left: 0;
		top: 0;
		background-color: #abb2ba;
		z-index: 1;
	}

	.loader3:before {
		content: "";
		position: absolute;
		background-color: #fff;
		top: -5px;
		left: 0px;
		height: 30px;
		width: 0px;
		z-index: 0;
		opacity: 1;
		-webkit-transform-origin: 100% 0%;
		transform-origin: 100% 0%;
		-webkit-animation: loader3 10s ease-in-out infinite;
		animation: loader3 10s ease-in-out infinite;
	}



	@-webkit-keyframes loader3 {
		0% {
			width: 0px;
		}

		70% {
			width: 100%;
			opacity: 1;
		}

		90% {
			opacity: 0;
			width: 100%;
		}

		100% {
			opacity: 0;
			width: 0px;
		}
	}

	@keyframes loader3 {
		0% {
			width: 0px;
		}

		70% {
			width: 100%;
			opacity: 1;
		}

		90% {
			opacity: 0;
			width: 100%;
		}

		100% {
			opacity: 0;
			width: 0px;
		}
	}

	/*  以上是 loading  */
	.bottom-layer {
		width: 60%;
		text-align: center;
		color: #197b93;
		display: flex;
		justify-content: space-between;
		position: absolute;
		left: 20%;
		bottom: 50px;
		background-repeat: no-repeat;
		background-size: 100%;
		font-size: 25px;
	}

	.top-layer {
		width: 100%;
		position: absolute;
		left: 0;
		top: 0;
	}

	.top-layer img {
		width: 100%;
		height: auto;
	}

	.bottom-btn {
		width: 250px;
		text-align: center;
		margin-left: 2.5%;
		cursor: pointer;
		opacity: 0.5;
	}

	.bottom-btn.active {
		opacity: 1;
	}

	.bottom-btn img {
		width: 150px;
	}


	.bottom-img {
		width: 80%;
		height: auto;
		position: absolute;
		bottom: 20px;
		left: 10%;
	}

	.center-layer {
		position: absolute;
		z-index: 99;
		width: 60%;
		left:50%;
		top:50%;
		transform: translate(-50%, -55%);
	}

	.center-layer-img{
		width: 100%;
		height: auto;
		opacity: 0.9;
	}
	.center-layer-con{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 999;
		width: 100%;
	}
	.center-layer-tittle{
		width: 100%;
		font-size: 30px;
		color: #fff;
		font-weight: bold;
		text-align: center;
	}
	.pop-top{
		display: flex;
	}
	.pop-imgs{
		width: 5vw;
		height: 5vw;
		margin-right: 20px;
	}
	.pop-cons{
		width: 300px;
		text-align: left;
	}
	.custom-btn {
	  width: 130px;
	  height: 40px;
	  color: #fff;
	  border-radius: 5px;
	  padding: 10px 25px;
	  font-family: 'Lato', sans-serif;
	  font-weight: 500;
	  background: transparent;
	  cursor: pointer;
	  transition: all 0.3s ease;
	  position: relative;

	  outline: none;
	}

	.btn-3 {
	  background: rgba(0, 80, 150,0);
	  /* background: linear-gradient(0deg, rgba(0, 0, 0, 1.0) 0%, rgba(1, 80, 159, 1.0) 100%); */
	  width: 130px;
	  height: 40px;
	  line-height: 42px;
	  padding: 0;
	  font-weight: bold;
	  border: none;
	  border-left: 1px solid #116eff;
	  border-right: 1px solid #116eff;
	}
	.btn-3 span {
	  position: relative;
	  display: block;
	  width: 100%;
	  height: 100%;
	}
	.btn-3:before,
	.btn-3:after {
	  position: absolute;
	  content: "";
	  right: 0;
	  top: 0;
	   background: rgba(2,126,251,1);
	   	  border: none;
	  transition: all 0.3s ease;
	}
	.btn-3:before {
	  height: 0%;
	  width: 2px;
	}
	.btn-3:after {
	  width: 0%;
	  height: 2px;
	}
	.btn-3:hover{
	   background: transparent;
	  box-shadow: none;
	}
	.btn-3:hover:before {
	  height: 100%;
	}
	.btn-3:hover:after {
	  width: 100%;
	}
	.btn-3 span:hover{
	   color: rgba(2,126,251,1);
	}
	.btn-3 span:before,
	.btn-3 span:after {
	  position: absolute;
	  content: "";
	  left: 0;
	  bottom: 0;
	   background: rgba(2,126,251,1);
	  transition: all 0.3s ease;
	}
	.btn-3 span:before {
	  width: 2px;
	  height: 0%;
	}
	.btn-3 span:after {
	  width: 0%;
	  height: 2px;
	}
	.btn-3 span:hover:before {
	  height: 100%;
	}
	.btn-3 span:hover:after {
	  width: 100%;
	}
</style>